<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
      }"
      height="128"
      card
      color="#fff"
    >
      <v-layout row wrap align-center>
        <v-flex xs12>
          <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:item="props">
              <router-link
                :to="props.item.href"
                :is="props.item.disabled ? 'span' : 'router-link'"
              >
                {{ props.item.text }}
              </router-link>
            </template>
            <template v-slot:divider>
              <v-icon>chevron_right</v-icon>
            </template>
          </v-breadcrumbs>
        </v-flex>
        <v-flex xs12>
          <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-block',
              backgroundColor: '#ef565c',
              borderRadius: '0.5rem',
            }"
          >
            <v-icon medium color="#fff">edit_square</v-icon>
          </div>
          <h1 style="display: inline">Editar Colegios</h1>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <div class="schedule-container">
      <v-container fluid grid-list-xl>
        <v-layout row wrap>
          <v-flex xs12 md12>
            <v-card flat class="border-container">
              <v-card-text>
                <v-flex xs12>
                  <div
                    class="mr-3"
                    :style="{
                      padding: '8px',
                      display: 'inline-block',
                      backgroundColor: '#ef565c',
                      borderRadius: '0.5rem',
                    }"
                  >
                    <img
                      :src="require('@/assets/icons/office_building.svg')"
                      alt=""
                    />
                  </div>
                  <spab style="display: inline">INFORMACIÓN DEL COLEGIO</spab>
                </v-flex>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <div class="border-container">
                      <span class="ml-2 mt-2">Nombre del colegio</span>
                      <v-text-field
                        hide-details
                        solo
                        flat
                        rounded
                        filled
                        required
                        v-model="$v.formCollege.nameCollege.$model"
                      />
                    </div>
                    <span
                      class="error-pass"
                      v-if="submitted && !$v.formCollege.nameCollege.required"
                      >Nombre del colegio es obligatorio</span
                    >
                  </v-flex>
                  <v-flex xs12 sm6>
                    <div class="border-container">
                      <span class="ml-2 mt-2">ID_Cliente (Opcional)</span>
                      <v-text-field
                        hide-details
                        solo
                        flat
                        rounded
                        filled
                        required
                        v-model="id_cliente"
                      />
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <div class="border-container">
                      <span class="ml-2 mt-2">Nombre del Administrador</span>
                      <v-text-field
                        hide-details
                        solo
                        flat
                        rounded
                        filled
                        required
                        v-model="$v.formCollege.nameAdmin.$model"
                      />
                    </div>
                    <span
                      class="error-pass"
                      v-if="submitted && !$v.formCollege.nameAdmin.required"
                      >Nombre del administrador es obligatorio</span
                    >
                  </v-flex>
                  <v-flex xs12 sm6>
                    <div class="border-container">
                      <span class="ml-2 mt-2">Apellido del Administrador</span>
                      <v-text-field
                        hide-details
                        solo
                        flat
                        rounded
                        filled
                        required
                        v-model="$v.formCollege.lastNameAdmin.$model"
                      />
                    </div>
                    <span
                      class="error-pass"
                      v-if="submitted && !$v.formCollege.lastNameAdmin.required"
                      >Apellido del Administrador es obligatorio</span
                    >
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <div class="border-container">
                      <span class="ml-2 mt-2">Correo del Administrador</span>

                      <v-text-field
                        hide-details
                        solo
                        flat
                        rounded
                        required
                        filled
                        v-model="$v.formCollege.emailAdmin.$model"
                      />
                    </div>
                    <div
                      v-if="submitted && $v.formCollege.emailAdmin.$error"
                      class="error-pass"
                    >
                      <span v-if="!$v.formCollege.emailAdmin.required"
                        >Correo electrónico del Administrador es
                        obligatorio</span
                      >
                      <span v-if="!$v.formCollege.emailAdmin.email"
                        >Ingrese un correo electronico valido</span
                      >
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <div class="border-container">
                      <span class="ml-2 mt-2">Dirección del colegio</span>
                      <v-text-field
                        hide-details
                        solo
                        flat
                        rounded
                        required
                        filled
                        v-model="$v.formCollege.address.$model"
                      />
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <div class="border-container">
                      <span class="ml-2 mt-2">Tipo de Cliente</span>

                      <v-layout row wrap>
                        <v-flex xs12 sm3 class="mb-3">
                          <v-checkbox
                            v-model="selectedClient.type"
                            :label="`Cliente`"
                            color="red"
                            class="ml-2"
                            :value="1"
                            hide-details
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12 sm3>
                          <v-checkbox
                            v-model="selectedClient.type"
                            :label="`Trial`"
                            color="red"
                            :value="2"
                            hide-details
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <div class="border-container">
                      <span class="ml-2 mt-2">{{
                        selectedClient.type === 1
                          ? 'Cantidad de licencias'
                          : 'Selecciona el periodo de prueba'
                      }}</span>

                      <v-layout v-if="selectedClient.type === 1" row wrap>
                        <v-flex sm4>
                          <v-text-field
                            hide-details
                            solo
                            flat
                            rounded
                            type="number"
                            required
                            v-model="$v.formCollege.numberLicences.$model"
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout v-else row wrap>
                        <v-flex xs12 sm3 class="mb-3">
                          <v-checkbox
                            v-model="selectedDay.day"
                            :label="`7 días`"
                            color="red"
                            class="ml-2"
                            hide-details
                            :value="7"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12 sm3>
                          <v-checkbox
                            v-model="selectedDay.day"
                            :label="`15 días`"
                            color="red"
                            hide-details
                            :value="15"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12 sm3>
                          <v-checkbox
                            v-model="selectedDay.day"
                            :label="`30 días`"
                            color="red"
                            hide-details
                            :value="30"
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </div>
                    <span
                      class="error-pass"
                      v-if="
                        submitted && !$v.formCollege.numberLicences.required
                      "
                      >Introduzca el numero de licencias</span
                    >
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <div class="container--btn mt-2 mb-2">
                <v-spacer></v-spacer>
                <v-btn @click="cancel()" class="custom-border" depressed outline
                  >Cancelar</v-btn
                >
                <v-btn
                  class="custom-border"
                  color="error"
                  style="font-size: 14px"
                  @click="updateCollege()"
                  depressed
                  >Guardar</v-btn
                >
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <Success
      v-model="success.modal"
      description="!Los datos se han actualizado exitosamente!"
    />
    <Cancel
      :value="CancelCollege.modal"
      title="¿Estas seguro que deseas cancelar la edición del colegio?"
      description="Esta acción eliminará los datos modificados."
      v-on:desition="cancelCollegeEvt"
    />
    <error v-model="toast.failed" :text="toast.eMessage"></error>
  </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators'

import error from '../../../../Dialogs/Error.vue'
import loading from '../../../../Dialogs/Loading.vue'
import Cancel from '../components/CancelCollege.vue'
import Success from '../components/SuccessSa.vue'

export default {
  components: {
    loading,
    Success,
    error,
    Cancel,
  },
  validations: {
    formCollege: {
      nameCollege: { required },
      nameAdmin: { required },
      lastNameAdmin: { required },
      emailAdmin: { required, email },
      numberLicences: { required },
      address: {},
    },
  },
  data: () => ({
    id_cliente: '',
    CancelCollege: {
      modal: false,
    },
    toast: {
      success: false,
      failed: false,
      eMessage: 'Ups ocurrió un error',
    },
    initialValues: null,
    formCollege: {
      nameCollege: '',
      nameAdmin: '',
      lastNameAdmin: '',
      emailAdmin: '',
      numberLicences: null,
      address: '',
    },
    inputChanges: {
      nameCollege: '',
      nameAdmin: '',
      lastNameAdmin: '',
      emailAdmin: '',
      idCustomer: '',
      numberLicences: null,
      address: '',
    },
    submitted: false,
    success: {
      modal: false,
    },
    selectedClient: { type: null },
    selectedDay: { day: 7 },
    breadcrumbs: [
      {
        text: 'Colegios',
        disabled: false,
        href: '/es/sa/panel/colleges',
      },
      {
        text: 'Editar Colegio',
        disabled: true,
        href: '/es/sa/panel/college/create',
      },
    ],
  }),
  computed: {},
  methods: {
    onlyOne(checkbox) {
      var checkboxes = document.querySelectorAll(
        '[name="active"], [name="inactive"]'
      )
      checkboxes.forEach((item) => {
        if (item !== checkbox) item.checked = false
      })
    },
    retrieveCollege(id_branch) {
      this.$store
        .dispatch('colleges/retrieveCollege', id_branch)
        .then(({ data }) => {
          this.formCollege = {
            nameCollege: data.name,
            numberLicences: data.licenses,
            nameAdmin: data.administrator.firstName,
            lastNameAdmin: data.administrator.lastName,
            emailAdmin: data.administrator.email,
            address: data.address,
          }
          ;(this.id_cliente = data.idCustomer),
            (this.selectedClient.type = data.type)

          this.inputChanges = {
            nameCollege: data.name,
            numberLicences: data.licenses,
            nameAdmin: data.administrator.firstName,
            lastNameAdmin: data.administrator.lastName,
            emailAdmin: data.administrator.email,
            idCustomer: data.idCustomer,
            address: data.address,
          }

          console.log(data)
        })
        .catch()
    },
    updateCollege() {
      let value = {
        name: this.formCollege.nameCollege,
        type: this.selectedClient.type,
        licenses: this.formCollege.numberLicences,
        trialExpiration: 1675274400000,
        idCustomer: this.id_cliente,
        address: this.formCollege.address,
        administrator: {
          firstName: this.formCollege.nameAdmin,
          lastName: this.formCollege.lastNameAdmin,
          email: this.formCollege.emailAdmin,
          password: 'the_password',
        },
      }
      this.submitted = true
      this.$v.formCollege.$touch()
      if (this.$v.formCollege.$invalid) {
        return
      }
      this.$store
        .dispatch('colleges/editCollege', {
          id_branch: this.$router.history.current.params.id,
          data: value,
        })
        .then((res) => {
          this.success.modal = true
          setTimeout(() => {
            this.success.modal = false
            this.$router.push({
              name: 'Colleges',
            })
          }, 3000)
        })
        .catch((error) => {
          console.log(error)
          this.toast.failed = true

          if (error.response) {
            switch (error.response.data) {
              case 'License value is lower than the current active student count.':
                this.toast.eMessage =
                  'el numero de licencias no puede ser menor al numero de alumnos'
                break
              case 'The provided email is not linked to the current branch administrator.':
                this.toast.eMessage =
                  'El correo electrónico proporcionado no está vinculado al administrador de la sucursal actual.'

                break
            }
          }
        })
    },
    changeLicenciaTrial() {
      this.cliente = false
    },
    changeLicenciaCliente() {
      this.trial = false
    },
    onCancel() {
      this.$router.push({
        name: 'Colleges',
      })
    },
    cancel() {
      if (
        this.inputChanges.nameCollege === this.formCollege.nameCollege &&
        this.inputChanges.numberLicences === this.formCollege.numberLicences &&
        this.inputChanges.nameAdmin === this.formCollege.nameAdmin &&
        this.inputChanges.lastNameAdmin === this.formCollege.lastNameAdmin &&
        this.inputChanges.emailAdmin === this.formCollege.emailAdmin &&
        this.inputChanges.idCustomer === this.id_cliente &&
        this.inputChanges.address === this.formCollege.address
      ) {
        console.log('NO Hubo cambios')
        this.$router.push('/es/sa/panel/colleges')
      } else {
        console.log('Hubo cambios')
        this.CancelCollege.modal = true
      }
    },
    cancelCollegeEvt(confirm) {
      if (confirm) {
        this.$router.push('/es/sa/panel/colleges')
      }

      this.CancelCollege.modal = false
    },
  },
  created() {},
  mounted() {
    this.retrieveCollege(this.$router.history.current.params.id)
  },
}
</script>

<style scoped>
.schedule-container {
  background-color: #f5f5f5;
  overflow-y: scroll;
  height: calc(100vh - 192px);
}
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}
.radio-border {
  border: 1px solid;
  border-color: #ccc;
  margin-bottom: 0 !important;
  padding: 1.5rem;
}
.radio-up {
  border-radius: 0.5rem 0.5rem 0px 0px;
}
.radio-down {
  border-radius: 0px 0px 0.5rem 0.5rem;
}
.radio-selected {
  background-color: #faeced;
  border-color: #f44336;
}
/* ::v-deep .v-input__slot {
 min-height: unset;
 height: 35px;
}
::v-deep  .v-text-field.v-text-field--solo .v-input__control {
  min-height: 30px;

    padding: 0;
} */
.radio--container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  height: 35px;
}
span {
  font-weight: 500;
}
.checks-type {
  display: flex;
  align-items: center;
}
.container--btn {
  display: flex;
  justify-content: flex-end;
}
.custom-border {
  border-radius: 0.5rem;
  background: #f44336;

  border-color: #ccc !important;
}
.color__btn-guardar {
  background: #f44336;
}
.error-pass {
  color: #f44336;
}
</style>
